import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38e94e0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1))
const _hoisted_5 = { class: "DialogSection" }
const _hoisted_6 = {
  key: 0,
  class: "DialogSection FlexColumn",
  style: {"width":"60%","flex":"auto"}
}
const _hoisted_7 = ["Key"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = {
  key: 1,
  class: "DialogSection FlexColumn",
  style: {"width":"60%","flex":"auto"}
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!

  return (_ctx.Access(_ctx.DialogData.Editing ? 'HR_Departments_Edit': 'HR_Departments_Create'))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: 'CookiesDialog_' + _ctx.DialogIndex,
        class: "CookiesDialogdBody"
      }, [
        (_ctx.Saving)
          ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.Loading.length > 0)
          ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              (_ctx.EmployeeData.Devices)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.EmployeeData.Devices as Array<HRDevices>), (Device) => {
                      return (_openBlock(), _createElementBlock("div", {
                        Key: Device.ID
                      }, [
                        (Device.Name)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_8, _toDisplayString(_ctx.Translate('Name' + ' : ' + Device.Name)), 1))
                          : _createCommentVNode("", true),
                        (Device.Brand)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_9, _toDisplayString(_ctx.Translate('Brand' + ' : ' + Device.Brand)), 1))
                          : _createCommentVNode("", true),
                        (Device.Type)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_10, _toDisplayString(_ctx.Translate('Type' + ' : ' + Device.Type)), 1))
                          : _createCommentVNode("", true),
                        (Device.Identifier)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_11, _toDisplayString(_ctx.Translate('ID' + ' : ' + Device.Identifier.substring(0, 5) )  + 'XXXXXX'), 1))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_7))
                    }), 256))
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.EmployeeData.Devices)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.DeviceOTP), 1),
                    (_ctx.OTPExpired)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_13, _toDisplayString(_ctx.Translate('OTP Expired')), 1))
                      : _createCommentVNode("", true),
                    (!_ctx.OTPExpired && _ctx.timer > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.timer) + " " + _toDisplayString(_ctx.Translate('Second')), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_15,
            _hoisted_16,
            (_ctx.Access(_ctx.DialogData.Editing ? 'HR_Departments_Edit': 'HR_Departments_Create'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    (_ctx.EmployeeData.Devices)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.DeleteDevice(_ctx.EmployeeData.Devices[0]))),
                          class: "F-Bold CookiesButton DialogFooterButton BGMain"
                        }, _toDisplayString(_ctx.Translate('Remove')), 1))
                      : _createCommentVNode("", true),
                    (!_ctx.EmployeeData.Devices && (_ctx.OTPExpired || !_ctx.DeviceOTP))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.GetOTP())),
                          class: "F-Bold CookiesButton DialogFooterButton BGMain"
                        }, _toDisplayString(_ctx.Translate('Assign Device')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}